import { render, staticRenderFns } from "./ActivityLogsItem.vue?vue&type=template&id=050676cc&scoped=true"
import script from "./ActivityLogsItem.vue?vue&type=script&lang=js"
export * from "./ActivityLogsItem.vue?vue&type=script&lang=js"
import style0 from "./ActivityLogsItem.vue?vue&type=style&index=0&id=050676cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050676cc",
  null
  
)

export default component.exports